// extracted by mini-css-extract-plugin
export var attribution = "_bx-4";
export var authorName = "_bx-5";
export var quote = "_bx-3";
export var testimonial = "_bx-2";
export var trustedBy = "_bx-0";
export var trustedByLabel = "_bx-1";